module.exports = __webpack_public_path__ + "img/kaist_gallery6.c0f1d41b.jpg";